class MultiEventHandler {
    constructor() {
        this.pendingEvents = {};
    }

    uniqEvent(key, event) {
        if (this.pendingEvents[key]) {
            return this.pendingEvents[key];
        }

        this.pendingEvents[key] = new Promise(async (resolve) => {
            resolve(event(() => { this.finishEvent(key) }));
        })

        return this.pendingEvents[key];
    }

    finishEvent(key) {
        delete this.pendingEvents[key];
    }
}

export default MultiEventHandler;